var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"px-2 rounded-lg",attrs:{"elevation":"0"}},[(!_vm.untitle)?_c('v-card-subtitle',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(!_vm.untitle)?_c('v-divider'):_vm._e(),_c('v-card-text',{staticClass:"px-4"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }